import { render } from "./VBookingDetails.vue?vue&type=template&id=a6c2fc6c"
import script from "./VBookingDetails.vue?vue&type=script&lang=js"
export * from "./VBookingDetails.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/bookdialysis/bookdialysis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__